import React, {Component} from 'react';
import {updateTotals, formatAmount} from "../lib/payment-utils";
import {moment} from "../lib/ext-refs";
import { ReceiptItemRow } from './receipt';


class PaymentComponentsView extends Component {

    render() {
        const {config, payments, showIcon, state} = this.props;
        const totalPaymentAmount = state.data.totalPaymentAmount;
        return (
            <div className="opp-section" id="PaymentComponentsView">
                <PaymentComponentsViewHeader
                    key={"PaymentComponentsViewHeader"}
                    config={config}
                    showIcon={showIcon}
                />
                <div className="row">
                    <div className="col-12">
                        <div className="card card-v2">
                            <div className="card-body">
                                <div className="payment-info-container">
                                    <PaymentComponentsViewBody
                                        key={"PaymentComponentsViewBody"}
                                        config={config}
                                        payments={payments}
                                        totalPaymentAmount={totalPaymentAmount}
                                        state={state}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class PaymentComponentsViewHeader extends Component {
    render() {
        const {config, showIcon} = this.props,
              {messages} = config;
        return (
            <h3 className="section-title">
                {showIcon && (
                    <span className="section-icon">
                            <img src={messages["opp.icon-payment-info"] || "images/icon-payment-items.png"}
                                 alt="Payment Information"/>
                        </span>)
                }
                <span
                    className="section-text">{messages["otp.paymentInfo.title"]}</span>
            </h3>
        )
    }
}


class PaymentComponentsViewBody extends Component {
  
    render() {
        const {config, payments, state, totalPaymentAmount} = this.props;
        const {messages, paymentConfig} = config;

        return (
            <div className="row payment-component-section">
                <div className="col-12">
                    <h4 className="subsection-title">{messages["payment.cm.single.label"]}</h4>
                    <table
                        className="table table-payment table-hover table-sm-custom table-bordered-simple table-vertical-middle payment-component-table">
                        <thead className="table-payment-thead">
                        <tr>
                            <th className="account-num-col dark-grey-text">Payment Component</th>
                            <th className="amount-due-col dark-grey-text text-right">Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        {payments.map(payment => { 
                            return (payment.bundle && payment.bundle[0] && payment.bundle[0].items[0]) &&
                                <tr key={payment.bundle[0].itemNumber} data-account={payment.bundle[0].amountDue}>
                                    <td className="account-num-col">{payment.bundle[0].items[0].description}</td>
                                    <td className="amount-due-col dark-grey-text text-right">
                                        {formatAmount(payment.bundle[0].items[0].amounts[0].amount || 0)}
                                    </td>
                                </tr>                                                                                                                                        
                        })}

                        <tr key="TOTAL" className="payment-info-total">
                            <td className="account-num-col">TOTAL</td>
                            <td className="amount-due-col dark-grey-text text-right">
                                {formatAmount(totalPaymentAmount || 0)}
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default PaymentComponentsView;
export {PaymentComponentsView, PaymentComponentsViewHeader, PaymentComponentsViewBody};
